import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';

function List() {

    const pathFrontEnd = '/bimanagers/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}bimanagers/delete`,
        endpoint: config.endpoints.backend + 'bimanagers/getall'
    }

    let list = {
        labelTitle: 'Lista de Gestor de BI',
        labelTitleButtonAdd: 'Incluir novo gestor de BI',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        columns: [
            {
                name: 'name',
                label: 'Nome do Gestor'
            },
            {
                name: 'company',
                label: 'Empresa'
            },
            {
                name: 'status',
                label: 'Status'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
